module.exports = __webpack_public_path__ + "img/36000.ade3d3a0.jpg";